<template>
	<div id="editquizzes" class="container-fluid">
		<div class="row mt-5">
			<!-- <div class="col-12 py-5">
				<h1>Deine Quizzes</h1>
				<!-- <button @click="increase"></button> - ->
			</div> -->
			<div class="col-12 col-md-3">
				<b-list-group>
					<b-list-group-item v-if="quizzes && quizzes.length == 0" class="py-3 text-info">
						<i class="fa fa-spin fa-spinner"></i>
					</b-list-group-item>

					<a class="list-group-item list-group-item-action" href="#" :class="{ 'active' : activeQuizKey == key }" v-for="(quiz, key) in quizzes"  :key="key" @click="openQuiz(key)">
						<i v-if="quiz.public" class="fa fa-globe fa-fw"></i> {{ quiz.name }}
					</a>

					<b-list-group-item>
						<p class="w-100">
							<b-form-input placeholder="Titel..." v-model="newQuizName"></b-form-input>
						</p>
						<p class="text-center w-100">
							<b-button @click="addQuiz" :disabled="newQuizName === ''" :variant="'warning'"><i class="fa fa-plus"></i> Quiz hinzufügen</b-button>
						</p>
					</b-list-group-item>
				</b-list-group>
			</div>
			<div v-if="activeQuizKey !== null" class="col-12 col-md-9">
				<div class="card">
					<div class="card-block">
						<div class="row">
							<div class="col-12 py-2 text-right">
								<b-form-checkbox v-model="activeQuiz.public" v-bind:true-value="true" v-bind:false-value="false">
									<!-- <b-form-checkbox v-model="activeQuiz.public"  value="true" unchecked-value="false"> -->
									{{ activeQuiz.public ? 'Öffentlich' : 'Nicht öffentlich'}}
								</b-form-checkbox>

								<!-- <b-button :to="{name: 'QuizByKey', params: {key: activeQuizKey}}" target="_blank">Preview</b-button> -->
								<b-button @click="preview" target="_blank">Preview</b-button>
								<b-button :variant="'success'" @click="updateQuiz" :disabled="!saveEligible">Speichern</b-button>
								<b-button :variant="'link'" :size="'sm'" v-on:dblclick.native="removeQuiz(activeQuizKey)" title="Löschen mit Doppelklick.">Löschen</b-button>
								<b-button :variant="'link'" :size="'sm'" @click="closeQuiz" title="Quiz schließen">schließen</b-button>
								<b-button :variant="'secondary'" :size="'sm'" @click="download" title="Quiz downloaden">Download</b-button>
							</div>
							<div class="col-12 py-2">
								<b-input-group left="Überschrift" :size="'lg'">
									<b-form-input v-model="activeQuiz.name"></b-form-input>
								</b-input-group>
								<b-form-input :textarea="true" v-model="activeQuiz.description" class="mt-2" placeholder="Beschreibung..."></b-form-input>
							</div>
						</div>
						<div class="row my-3">
							<div class="col-8">
								<div class="list-group" id="items">
									<div v-for="(question, key) of activeQuiz.questions" :key="question" class="list-group-item mb-2 border-0 px-0">
										<div class="col-12 px-0">
											<h6>
												<i class="fa fa-arrows-alt fa-fw handle"></i>
												{{ key + 1}}. Frage
												<b-button v-on:dblclick.native="removeQuestion(key)" :variant="'link'"  :size="'sm'" class="text-muted pull-right">entfernen</b-button>
											</h6>
										</div>
										<!-- {{activeQuiz.questions[key].content}} -->
										<div :is="'question-' + question.type + '-edit'" :question="question" :questionKey="key" v-on:remove="removeQuestion" class="col-12 px-0"></div>	
									</div>
								</div>
								<div>
									<b-button v-for="(type, key) in questionTypes" @click="addQuestion(type.id)" :key="key"><i class="fa fa-plus fa-fw"></i> {{type.buttonText}}</b-button>
								</div>
							</div>
							<div class="col-4">
								<div v-if="activeQuiz.variables && activeQuiz.variables.length > 0" class="row">
									<div class="col-3">Name</div>
									<div class="col-3 ml-1">von</div>
									<div class="col-3 ml-1">bis</div>
								</div>

								<div v-for="(variable, variableKey) of activeQuiz.variables" :key="variableKey" class="row mb-2">
									<b-form-input :type="'text'" v-model="variable.name" class="col-3"></b-form-input>
									<b-form-input :type="'number'" v-model="variable.from" class="col-3 ml-1"></b-form-input>
									<b-form-input :type="'number'" v-model="variable.to" class="col-3 ml-1"></b-form-input>
									<b-button @click="removeVariable(variableKey)" class="col-2" :variant="'link'"><i class="fa fa-times fa-fw"></i></b-button>
								</div>

								<b-button @click="addVariable" class="pull-right mt-2"><i class="fa fa-plus fa-fw"></i> Variable</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="col-12 col-md-9">
				<h3>So geht's</h3>
				<dl class="mt-5">
					<dt>Videos</dt>
					<dd>
						Um Videos einzubinden schreibt man:
						<code>[video:http://www.youtube.com/embed/<strong>DLzxrzFCyOs</strong>?rel=0]</code>
					</dd>
				</dl>

				<dl class="mt-5">

					<dt>:Variablen:</dt>
					<dd>Den Namen der Variablen einfach in ":" setzen.<br> <code>:a: + :b:</code> wird zu <code>3 + 4</code>, wenn a = 3 und b = 4.</dd>
				</dl>
				<dl class="mt-5">
					<dt>$Latex$</dt>
					<dd>
						Latex ist via <a href ="https://www.mathjax.org/" target="_blank">MathJax</a> möglich. Also einfach in Dollarzeichen setzen.<br>
						<code>$ :a: \over :b:$</code> ergibt einen schönen Bruch.<br>
						Mit zwei Dollarzeichen wird die Mathematik in einer Zeile mittig angezeigt.
					</dd>
				</dl>
				<dl class="mt-5">
					<dt>§Berechnungen§</dt>
					<dd>
						Möchte man etwas berechnen lassen, stellt man den mathematischen Ausdruck in Paragrafen.<br>
						<code>§3+4§</code> ergibt <code>7</code><br>
						Dies ist auch in Verbindung mit Variablen möglich.<br>
						<code>§ :a:/:b:§</code> ergibt <code>0,75</code>.
					</dd>
				</dl>
				<dl class="mt-5">
					<dt>Komplexere Berechnungen</dt>
					<dd>
						Die gängisten Funktionen sind via <a href ="http://mathjs.org/" target="_blank">math.js</a> in Berechnungen verfügbar.<br>
						<code>§ round( sin( 40 deg), 2)§</code> ergibt <code>0,64</code>.
					</dd>
				</dl>
			</div>
		</div>
	</div>
</template>

<script>
	import autosize from "autosize";
	import Sortable from 'sortablejs'

	import {questionTypes} from '../helper.js'

	export default {
		
		data(){
			return {
				activeQuizKey: null,
				activeQuiz: {},
				newQuizName: '',
				questionTypes: questionTypes,
				list: []
			}
		},
		methods: {
			preview(obj){
				console.log('Obj:', obj)
				this.updateQuiz()

				window.open('/' + this.activeQuizKey,'_blank');
			},

			increase(){
				console.log('Davor: ', this.list)
				this.list.push({bla: this.list.length})
				console.log('Danach: ', this.list)
			},
			addVariable(){
				this.activeQuiz.variables
				? this.activeQuiz.variables.push({name: String.fromCharCode( this.activeQuiz.variables.length + 97), from: 1, to: 10})
				: this.activeQuiz.variables = [{name: 'a', from: 1, to: 10}]
			},

			removeVariable(variableKey){
				this.activeQuiz.variables.splice(variableKey, 1)
			},

			addQuestion(type){
				console.log('Active Quiz: ', this.activeQuiz)
				
				let question = {type: type}

				this.activeQuiz.questions
				? this.activeQuiz.questions.push(question)
				: this.activeQuiz.questions = [question]
			},
			removeQuestion(key){
				console.log('removeQuestion', key)

				this.activeQuiz.questions.splice(key, 1)
			},
			addQuiz: function(e){
				let quiz = {
					name: this.newQuizName,
					uid: this.$store.state.user.uid,
					public: false,
					questions: []
				}

				let a = this.$store.state.db.ref('/quizzes').push(quiz)
				this.$store.commit('addQuiz', {key: a.key, ...quiz})
				// this.$store.commit('updateQuiz', {key: a.key, quiz: quiz})

				this.openQuiz(a.key)

				this.newQuizName = ''
			},
			removeQuiz(key){
				console.log('Remove', key)
				this.$store.commit('removeQuiz', key)
				this.activeQuizKey = null
				this.activeQuiz = {}
			},
			updateQuiz(){

				if(!this.activeQuiz.variables){
					this.activeQuiz.variables = []
				} 

				this.$store.commit('updateQuiz', {key: this.activeQuizKey, quiz: this.activeQuiz})
			},
			openQuiz(key){
				console.log('Should activate.', key)
				// this.activateQuizKey = this.quizzes[key]
				this.activeQuizKey = key
				this.activeQuiz = this.quizzes[key]

				// console.log('Update Quiz', this.activeQuiz)

				this.$set(this.activeQuiz, 'questions', this.activeQuiz.questions)
				this.$set(this.activeQuiz, 'variables', this.activeQuiz.variables)
				// this.$set(this.activeQuiz.questions, 'alternatives', this.activeQuiz.questions[].alternatives)
			},
			closeQuiz(){
				this.activeQuizKey = null
				this.activeQuiz = {}
			},
			download(){
				//thx: https://stackoverflow.com/questions/2897619/using-html5-javascript-to-generate-and-save-a-file
				console.log('Download')

				var content = JSON.stringify(this.activeQuiz)

				console.log('content: ', content)

				// let uriContent = "data:application/octet-stream," + encodeURIComponent(content);
				// let newWindow = window.open(uriContent, 'neuesDokument');


				var pom = document.createElement('a');
				pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
				pom.setAttribute('download', this.activeQuiz.name + '.json');

				if (document.createEvent) {
					var event = document.createEvent('MouseEvents');
					event.initEvent('click', true, true);
					pom.dispatchEvent(event);
				}
				else {
					pom.click();
				}
			}
		},

		computed: {
			quizzes(){
				return this.$store.state.quizzes
			},

			saveEligible(){
				return true

				let q = this.activeQuiz

				console.log('saveEligible', q)

				if( q.name == '')
					return false
				
				// if( q.description == '')
				// 	return false

				if(!q.questions)
					return false

				if(q.questions.length == 0)
					return false

				console.log('Bis hier hin alles gut.')

				let hit = false
				q.questions.forEach( v => {
					if(v.answer == '' || v.content == '' || v.answer == undefined || v.content == undefined)
						hit = true
				})

				console.log('Hit: ', hit)

				return hit ? false : true
			}
		},

		beforeCreate(){

			if(this.$store.state.user.isAnonymous){
				this.$router.replace('/login')
			}

			this.$store.dispatch('loadQuizzes')
		},

		updated(){
			var el = document.getElementById('items');
			// console.log('Ganz Davor', this.activeQuiz.questions)
			if(el){	
				var sortable = Sortable.create(el,{
					handle: '.handle',
					onUpdate: (event) => {
						/* Warum liefert Davor und Danach das gleiche bereits geänderte Array-Ergebnis? */
						/* Wie schaffe ich es, dass sich die Werte auch innerhalb der Child-Components ändern und nicht? 
						* Antwort: einfach nur key als :key zu nehmen ist dumm
						*/

						// console.log('Davor', this.activeQuiz.questions)
						// console.log('Old: ', event.oldIndex, 'New: ', event.newIndex)

						this.activeQuiz.questions.splice(event.newIndex+1, 0, this.activeQuiz.questions[event.oldIndex])
						// console.log('Dazwischen', this.activeQuiz.questions)
						let adder = event.newIndex < event.oldIndex ? 1 : 0
						console.log('remove vom index: ', event.oldIndex + adder)
						this.activeQuiz.questions.splice(event.oldIndex+adder, 1)


						// this.$forceUpdate()
						// console.log('Danach', this.activeQuiz.questions)
					}
				});
			}


			autosize(document.querySelectorAll("textarea"));
			autosize.update(document.querySelectorAll("textarea"));
		},

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// EditQuizzes.vue?5a281412